import React from 'react';
import { isEmptyString } from '../../lib/Utils';


const NumberFormatter = (props) =>{
  let { value, emptyText, color } = props;
  value = parseFloat(value);
  if (isEmptyString(value) || isNaN(value)) {
    return <div><font color="lightGrey">
      {emptyText}
  </font></div>;
  }
  return <div><font color={color}>{value.toFixed(0)} </font></div>;
};

export default NumberFormatter;



// WEBPACK FOOTER //
// ./src/components/NumberFormatter/NumberFormatter.js